<template>
    <div style="height:100%">
        <div class="toolbar">
            <el-button type="primary" size="small" @click="beginDraw">剖面分析</el-button>
        </div>
        <div id="csContainer">
            <div id="main" style="width: 380px;height:230px;display: none"></div>
        </div>
        <div id="loadingOverlay"><h1>Loading........</h1></div>
<!--        <div class="div-charts"></div>-->
    </div>
</template>

<script>
    import echarts from 'echarts';
    import util from "../../components/util"

    export default {
        data() {
            return {
                viewer: null,
                myChart:null,
                start : null,
                end : null,
                terrainProvider:null,
            }
        },
        mounted() {
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
         },4000);
            this.init();
        },
        methods: {
            init() {

                let terrainProvider = Cesium.createWorldTerrain();
                let viewer = util.getViewer("csContainer", {
                    terrainProvider: terrainProvider
                });
                // viewer.scene.globe.depthTestAgainstTerrain = true;
                this.viewer = viewer;
                viewer.camera.setView({
                    destination: new Cesium.Cartesian3(-548184.7982559408, 5512367.059463563, 3173625.2210259973),
                    orientation: {
                        heading: 5.683499859605618,
                        pitch: -0.3430291183891061,
                        roll: 6.281444671468591
                    }
                });
            },
           beginDraw() {
                // 重置
               this.$message({
                   showClose: true,
                   message: '鼠标左键单击绘制起点，第二次单击绘制终点并开始分析',
                   duration: 10000
               });
               let viewer = this.viewer;
               let myChart = this.myChart;
               let terrainProvider = this.terrainProvider;
               let dom = document.getElementById('main'); // 绘图对象
                dom.style.display = "none";
                viewer.entities.removeAll();
                let start = null;
                let end = null;
                viewer.screenSpaceEventHandler.setInputAction(function (clickEvent) {
                    if (start == null) {
                        start = viewer.scene.pickPosition(clickEvent.position);
                        drawPoint(start);
                        viewer.screenSpaceEventHandler.setInputAction(function (moveEvent) {
                            end = viewer.scene.pickPosition(moveEvent.endPosition);
                            drawLine();
                        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                    } else {
                        end = viewer.scene.pickPosition(clickEvent.position);
                        drawPoint(end);
                        viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
                        viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
                        profileAnalyse();
                    }
                }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
               function drawPoint(position) {
                   viewer.entities.add({
                       position: position,
                       point: {
                           size: 10,
                           color: Cesium.Color.GREEN
                       }
                   })
               }

               function drawLine() {
                   viewer.entities.add({
                       polyline: {
                           positions: new Cesium.CallbackProperty(function () {
                               return [start, end]
                           },false),
                           material: Cesium.Color.RED,
                           clampToGround: true,
                           classificationType: Cesium.ClassificationType.BOTH
                       }
                   })
               }



               function profileAnalyse() {
                   var positions = [Cesium.Cartographic.fromCartesian(start)];
                   // 插值100个点，点越多模拟越精确，但是效率会低
                   var count = 100;
                   for (var i = 1; i < count; i++) {
                       var cart = Cesium.Cartesian3.lerp(start, end, i / count, new Cesium.Cartesian3());
                       positions.push(Cesium.Cartographic.fromCartesian(cart));
                   }
                   positions.push(Cesium.Cartographic.fromCartesian(end));

                   // 异步使用最精确的地形采样获取地形高度
                   var promise = Cesium.sampleTerrainMostDetailed(viewer.terrainProvider, positions);
                   Cesium.when(promise, function (updatedPositions) {

                       // 处理返回的数据
                       var height = [];
                       for (var i = 0; i < updatedPositions.length; i++) {
                           height.push(updatedPositions[i].height); // 取得高程值
                       }

                       // 绘制高程走势图
                       dom.style.display = "block";

                       // 使用Echart等图表工具可视化
                       if (myChart == null) {
                           myChart = echarts.init(dom);
                           initChart(height, false);
                       } else {
                           initChart(height, true);
                       }

                   });
               }

               function initChart(height, isMerge) {
                   var option = {
                       title: {
                           text: '海拔走势图'
                       },
                       tooltip: {
                           trigger: 'axis',
                           axisPointer: {
                               type: 'cross',
                               label: {
                                   backgroundColor: '#6a7985'
                               }
                           }
                       },
                       legend: {
                           data: ['海拔走势图']
                       },
                       toolbox: {
                           feature: {
                               saveAsImage: {show: true, title: '保存'}
                           }
                       },
                       grid: {
                           left: '3%',
                           right: '4%',
                           bottom: '3%',
                           containLabel: true
                       },
                       xAxis: [
                           {
                               type: 'category',
                               boundaryGap: false
                           }
                       ],
                       yAxis: [
                           {
                               type: 'value'
                           }
                       ],
                       series: [
                           {
                               name: '海拔走势图',
                               type: 'line',
                               stack: '总量',
                               label: {
                                   normal: {
                                       show: true,
                                       position: 'top'
                                   }
                               },
                               areaStyle: {normal: {}},
                               data: height
                           }
                       ]
                   };
                   myChart.setOption(option, isMerge);
               }

    }


        }
    }
</script>

<style scoped>
    #csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    #main {
        z-index: 1;
        position: absolute;
        top: 80px;
        left: 10px;
        background-color: white;
    }

</style>
